import get from 'lodash/get';
import { CheckoutState } from '../state';

export const getIsMultiValueTargetingRulesAttributeEnabled = (
    state: CheckoutState,
    featureFlag: string,
    attribute: string,
) => get(state, `splitioMultiValueTargetingRules.${featureFlag}.${attribute}`);
